import { SvgIcon, type SvgIconProps } from './svgIcon'

export function SkFlagIcon({
  width = 18,
  height = 18,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        d="M9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5Z"
        fill="#F0F0F0"
      />
      <path
        d="M9 18.5015C13.9705 18.5015 18 14.472 18 9.50151C18 8.40063 17.802 7.34605 17.4402 6.37109H0.559793C0.198035 7.34605 0 8.40063 0 9.50151C0 14.472 4.02947 18.5015 9 18.5015Z"
        fill="#0052B4"
      />
      <path
        d="M9.00271 18.4985C12.8724 18.4985 16.1713 16.0561 17.4429 12.6289H0.5625C1.83414 16.0561 5.13302 18.4985 9.00271 18.4985Z"
        fill="#D80027"
      />
      <path
        d="M2.32812 5.58594V10.0756C2.32812 12.6295 5.66449 13.412 5.66449 13.412C5.66449 13.412 9.00082 12.6295 9.00082 10.0756V5.58594H2.32812Z"
        fill="#F0F0F0"
      />
      <path
        d="M3.10938 5.58594V10.0756C3.10938 10.3754 3.17596 10.6586 3.30787 10.924H8.01835C8.15025 10.6586 8.21684 10.3754 8.21684 10.0756V5.58594H3.10938Z"
        fill="#D80027"
      />
      <path
        d="M7.23198 8.7189H6.05811V7.93629H6.84073V7.15367H6.05811V6.37109H5.2755V7.15367H4.49292V7.93629H5.2755V8.7189H4.10156V9.50151H5.2755V10.2841H6.05811V9.50151H7.23198V8.7189Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.37214 12.0168C4.87645 12.3338 5.39459 12.5178 5.65984 12.5996C5.92509 12.5178 6.44323 12.3338 6.94754 12.0168C7.45611 11.6972 7.81263 11.3316 8.01506 10.9244C7.79178 10.7664 7.51936 10.6732 7.22507 10.6732C7.11791 10.6732 7.01381 10.6859 6.91372 10.7092C6.70162 10.2273 6.22016 9.89062 5.65987 9.89062C5.09959 9.89062 4.61809 10.2273 4.40603 10.7092C4.30594 10.6859 4.2018 10.6732 4.09468 10.6732C3.80039 10.6732 3.52796 10.7664 3.30469 10.9244C3.50701 11.3316 3.86353 11.6972 4.37214 12.0168Z"
        fill="#0052B4"
      />
    </SvgIcon>
  )
}
